import React, { useEffect, useMemo, useState } from 'react'
import FeedbackSummaryListUi from './FeedbackSummaryListUi'
import { getDashboardFeedbackSummaryApi, getDashboardVideoSummaryApi } from '../../apis/dashboard.api';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import { callApiAction } from '../../store/actions/commonAction';
import moment from 'moment';
import fileDownload from 'js-file-download';

const FeedbackSummaryListController = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [list, setlist] = useState()
    const [exportLoading, setexportLoading] = useState(false)
    const [filters, setFilters] = useState({
        pageNo: 1,
        pageSize: 10,
        search: "",
        sort: "donation_date",
        sort: "eventName",
        sortDirection: 1,
    });

    const fetchList = () => {
        setLoading(true);
        dispatch(
            callApiAction(
                async () => await getDashboardFeedbackSummaryApi({ ...filters }),
                (response) => {
                    setLoading(false);
                    setlist(response);
                },
                (err) => {
                    setLoading(false);
                }
            )
        );
    }
    const fetchCsvList = () => {
        setexportLoading(true);
        dispatch(
            callApiAction(
                async () => await getDashboardFeedbackSummaryApi({ ...filters, isCsv: true }),
                (response) => {
                    setexportLoading(false);
                    fileDownload(response, "FeedbackSummary.csv")
                },
                (err) => {
                    setexportLoading(false);
                }, true
            )
        );
    }

    const columns = useMemo(
        () => [
            {
                id: 1,
                fieldName: "eventName",
                label: "Event Name",
                align: "left",
                sort: true,
                minWidth: 180,
                renderValue: (params, setParams) => params?.eventName,
            },
            {
                id: 2,
                fieldName: "totalBeneficiaries",
                label: "Total Beneficiaries",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.totalBeneficiaries,
            },
            {
                id: 3,
                fieldName: "donation_date",
                label: "Event Donation Date",
                align: "left",
                sort: true,
                renderValue: (params, setParams) => moment(params?.donation_date).format("DD/MM/YYYY"),
            },
            {
                id: 4,
                fieldName: "F1",
                label: "F1",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.F1,
            },
            {
                id: 5,
                fieldName: "F2",
                label: "F2",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.F2,
            },
            {
                id: 6,
                fieldName: "F3",
                label: "F3",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.F3
            },
            {
                id: 7,
                fieldName: "F4",
                label: "F4",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.F4
            },

            {
                id: 8,
                fieldName: "F5",
                label: "F5",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.F5,
            },
            {
                id: 9,
                fieldName: "F6",
                label: "F6",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.F6,
            },
            {
                id: 10,
                fieldName: "F7",
                label: "F7",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.F7,
            },
            {
                id: 11,
                fieldName: "F8",
                label: "F8",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.F8,
            },
            {
                id: 12,
                fieldName: "hearingState",
                label: "HearingState",
                align: "left",
                sort: false,
                minWidth: 170,
                renderValue: (params, setParams) => {
                    const hearingState = params?.hearingState;
                    if (!hearingState || typeof hearingState !== "object") return "";

                    return params?.hearingState?.field !== undefined && params?.hearingState?.value !== undefined  ?
                        `${params?.hearingState?.field} = ${params?.hearingState?.value}` :
                        Object.entries(hearingState).map(([key, value]) => `${key} = ${value}`).join(", ");
                }
            },
            {
                id: 13,
                fieldName: "speechState",
                label: "SpeechState",
                align: "left",
                sort: false,
                minWidth: 160,
                renderValue: (params, setParams) => {
                    const speechState = params?.speechState;
                    if (!speechState || typeof speechState !== "object") return "";

                    return params?.speechState?.field !== undefined && params?.speechState?.value !== undefined  ?
                        `${params?.speechState?.field} = ${params?.speechState?.value}` :
                        Object.entries(speechState).map(([key, value]) => `${key} = ${value}`).join(", ");
                },
            },
            {
                id: 14,
                fieldName: "inclusionState",
                label: "InclusionState",
                align: "left",
                sort: false,
                minWidth: 180,
                renderValue: (params, setParams) => {
                    const inclusion = params?.inclusionState;
                    if (!inclusion || typeof inclusion !== "object") return "";

                    return params?.inclusionState?.field !== undefined && params?.inclusionState?.value !== undefined ?
                        `${params?.inclusionState?.field} = ${params?.inclusionState?.value}` :
                        Object.entries(inclusion).map(([key, value]) => `${key} = ${value}`).join(", ");
                  },
            }
        ],
        []
    );

    const onExportBtnClick = () => {
        fetchCsvList()
    }

    useEffect(() => {
        fetchList();
    }, [filters])
    return (
        <FeedbackSummaryListUi
            setlist={setlist}
            list={list}
            filters={filters}
            setFilters={setFilters}
            loading={loading}
            columns={columns}
            onExportBtnClick={onExportBtnClick}
            exportLoading={exportLoading}
        />
    )
}

export default FeedbackSummaryListController